import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MotesModalComponent } from './motes-modal.component';

@NgModule({
    declarations: [
        MotesModalComponent,
    ],
    imports: [
        CommonModule
    ],
    exports: [
        MotesModalComponent
    ]
})
export class MotesModalModule { }

